


  
  <div class="relative w-full">
    <!-- Background Image -->
    <img 
      [src]="tenant.getImg(tenant.HERO)" 
      alt="Hero Background"
      class="w-full h-[420px] object-cover">

   

    <!-- Text Content -->
     <div class="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
    <div  *ngIf="status === 'success'" >
      <h1 class="text-5xl text-white font-extrabold mb-2">Thank You!</h1>
      <p class="text-2xl font-semibold">You've been entered for a chance to win. Stay tuned!</p>
     
      
   
    </div>

    <div *ngIf="status === 'error'" >
      <h1 class="text-3xl text-white font-extrabold mb-2 pt-6">You have already submitted an entry.</h1>
      <p class="text-2xl font-semibold">Emails and phone numbers are only eligible for one entry per event.</p>
   
      
    </div>

     <p class="text-xl font-semibold pt-6">Want to learn more?</p>
     <button [style.color]="loadeddata?.PrimaryColor" type="submit" class="mt-4 bg-white text-white font-bold p-3 rounded-lg transition"
		routerLink="/{{this.tenant.getName()}}/why">
      Why {{this.loadeddata['Name']}}?
     </button>
     </div>
  </div>


  <div class="text-white py-6 px-4 " [style.backgroundColor]="loadeddata?.PrimaryColor">
    <h2 class="text-center text-white font-semibold mb-6">PREMIUM GIVEAWAYS INCLUDES:</h2>

  
    <div class="grid grid-cols-4 md:grid-cols-4 gap-6 text-center">

      <div *ngFor="let item of iconsWithLabels">
    <img [src]="item.icon" [alt]="item.label" class="mx-auto h-10 md:h-12 mb-2">
    <p class="text-sm">{{ item.label }}</p>
  </div>
     
     
    </div>
  </div>



  
  




